// extracted by mini-css-extract-plugin
module.exports = {"paper":"MobileMockup_paper__3P_Yp","closeBtn":"MobileMockup_closeBtn__2R4ln","openBtn":"MobileMockup_openBtn__tlh_B","dialogBackdrop":"MobileMockup_dialogBackdrop__2Blwe"};